import { Link, useSearchParams } from 'react-router-dom';
import { AuthShell } from '@/components/auth/AuthShell';
import { usePageMeta } from '@/hooks/use-page-meta';

const STATES = {
  success: {
    title: 'Email verified',
    body: 'Your email address is confirmed. You can now sign in and start your first interview.',
    tone: 'tone-success',
  },
  expired: {
    title: 'Link expired',
    body: 'This verification link has expired. Sign in and request a new verification email.',
    tone: 'tone-warn',
  },
  invalid: {
    title: 'Invalid link',
    body: "We couldn't verify your email with this link. It may have already been used, or the account may no longer need verification.",
    tone: 'tone-error',
  },
} as const;

export function EmailVerified() {
  usePageMeta("Email verified — Aura", { noindex: true })
  const [params] = useSearchParams();
  const status = params.get('status');
  const state = STATES[(status as keyof typeof STATES) ?? 'invalid'] ?? STATES.invalid;

  return (
    <AuthShell title={state.title} subtitle={undefined} footer={undefined}>
      <p className={`auth-status ${state.tone}`}>{state.body}</p>
      <Link to="/login" className="btn btn-primary" style={{ width: '100%', marginTop: 8 }}>
        Go to sign in
      </Link>
    </AuthShell>
  );
}
